
import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from "@shared/components/ui/select";
import { ExperienceDropdownItem } from "@features/booking/components/ExperienceDropdownItem";
import { ExperienceSeparator } from "@features/booking/components/ExperienceSeparator";

interface Experience {
  id: string;
  title: string;
}

interface ExperienceSelectorProps {
  experiences: Experience[];
  selectedExp: string;
  onExperienceChange: (value: string) => void;
  getSelectedExperienceLabel: () => string;
}

const ExperienceSelector = ({
  experiences,
  selectedExp,
  onExperienceChange,
  getSelectedExperienceLabel,
}: ExperienceSelectorProps) => (
  <div className="w-full flex flex-col items-center mb-4 space-y-2">
    <Select value={selectedExp} onValueChange={onExperienceChange}>
      <SelectTrigger
        aria-label="Change experience"
        className="flex items-center w-full max-w-xs justify-between px-4 py-3 rounded-lg bg-card border border-border text-foreground text-base font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-brand h-auto min-h-0 min-w-0"
      >
        <SelectValue placeholder="Select experience">
          {getSelectedExperienceLabel()}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="z-[60] bg-card border border-border rounded-xl shadow-lg">
        {experiences.map((exp, idx) => (
          <ExperienceDropdownItem 
            key={exp.id}
            experience={exp}
            disabled={idx === 2}
            isSoldOut={idx === 2}
          />
        ))}
      </SelectContent>
    </Select>
    <ExperienceSeparator />
  </div>
);

export default ExperienceSelector;
